export enum LiabilityTypes {
  MORTGAGE = 'Mortgage debt',
  CREDIT_CARD = 'Credit card debt',
  CAR_LOAN = 'Car loan',
  STUDENT_LOAN = 'Student loan',
  OTHER = 'Other debt',
}
